import { render, staticRenderFns } from "./ComingSoonIcon.vue?vue&type=template&id=7b9c9c68&scoped=true"
import script from "./ComingSoonIcon.vue?vue&type=script&lang=js"
export * from "./ComingSoonIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b9c9c68",
  null
  
)

export default component.exports